import { isPublicRoute } from '@client/trpc/sessionHandling';
import { useLocation } from '@tanstack/react-router';

export function useIsPublicSection(): boolean {
    const { pathname } = useLocation();
    return isPublicRoute(pathname);
}
